export default __webpack_public_path__ + "8029b9c02e792086324c3ab40bc9cfa7.jpg";